jQuery(function ($) {

  $('#search-results-container, #search-link, .container-info').on("click", ".add-job-offer-favorite", function (e) {
    e.preventDefault();
    addJobOfferFavorite($(this));
  });

  $('.dashboard-espace-candidat').on("click", ".delete-job-offer-favorite", function (e) {
    e.preventDefault();
    deleteJobOfferFavorite($(this));
  });

  /**
   * Add Job Offer Fovarite Call Ajax
   * @param dataFavorite
   */
  function addJobOfferFavorite(dataFavorite) {
    var divFavorite = dataFavorite.data('favorite');
    var self = dataFavorite;

    $.ajax({
      url: '/ajax/espace-candidat/add-favorite',
      type: 'POST',
      data: {
        'id_job_offer': divFavorite
      },
      dataType: 'json',
      success: function (success) {
        if (success.data == 200) {
          if (success.favorite) {
            if ($(self).hasClass('active')) {
              $(self).find('.icon').removeClass('active');
            } else {
              $(self).find('.icon').addClass('active');
            }
          } else {
            $(self).find('.icon').removeClass('active');
          }
        } else {
          window.location.href = '/connexion';
        }
      }, error: function (xhr, ajaxOptions, thrownError) {
        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  }

  /**
   * Delete Job Offer Favorite Call Ajax
   * @param dataFavorite
   */
  function deleteJobOfferFavorite(dataFavorite) {
    var divFavorite = dataFavorite.data('favorite');
    var self = dataFavorite;

    $.ajax({
      url: '/ajax/espace-candidat/remove-favorite',
      type: 'POST',
      data: {
        'id': divFavorite
      },
      dataType: 'json',
      success: function (success) {
        self.parent().remove();
      }, error: function (xhr, ajaxOptions, thrownError) {
        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  }
});
